export type Variant = 'a' | 'b' | 'c' | 'd' | 'e';

export const INITIAL_VARIANT: Variant = 'a';

export const VARIANTS: Record<Variant, Record<string, string>> = {
  a: {
    stroke: 'hsl(45deg 100% 50%)',
    'stroke-width': '6px',
    'stroke-dasharray': '20, 14',
    'stroke-linecap': 'butt',
  },
  b: {
    stroke: 'oklch(0.7 0.2 348)',
    'stroke-width': '16px',
    'stroke-dasharray': '0, 15',
    'stroke-linecap': 'round',
  },
  c: {
    stroke: 'oklch(0.9 0.2 179)',
    'stroke-width': '4px',
    'stroke-dasharray': '0, 10, 25, 10',
    'stroke-linecap': 'square',
  },
  d: {
    stroke: 'white',
    'stroke-width': '10px',
    'stroke-dasharray': '0, 20, 26, 60',
    'stroke-linecap': 'round',
  },
  e: {
    stroke: 'hsl(10deg 100% 80%)',
    'stroke-width': '12px',
    'stroke-dasharray': '3, 12',
    'stroke-linecap': 'butt',
  },
};

export function generateSnippet(variant: Variant) {
  const styles = VARIANTS[variant];

  const styleString = Object.entries(styles)
    .map(([key, value]) => `    ${key}: ${value};`)
    .join('\n');

  // HACK: Surprisingly tricky getting an empty line to actually stay in this string! Prettier strips out the space.
  const extraSpace = '\n \n';

  return `
<style>
  circle {
${styleString}
  }
</style>
${extraSpace}
<svg viewBox="0 0 200 200">
  <circle cx="100" cy="100" r="50" />
</svg>
  `;
}
